module.exports = __webpack_public_path__ + "static/media/building8.4739862d.png";